import { Popover } from "antd";
import { CalendarIcon, Clock, Headphones, MoreHorizontal, Trash } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function PodcastDetail() {
  const navigate = useNavigate();

  const { eventos } = useSelector((state) => state.evento);

  // Obtener el estado del podcast desde Redux
  const { podcast, loading } = useSelector((state) => state.podcast);

  // Mostrar un mensaje de carga si los datos aún no están disponibles
  if (loading) {
    return <div className="w-full min-h-[91.1vh] flex items-center justify-center">Cargando...</div>;
  }

  // Mostrar un mensaje si no hay datos del podcast
  if (!podcast) {
    return <div className="w-full min-h-[91.1vh] flex items-center justify-center">No se encontró información del podcast.</div>;
  }

  return (
    <div className="w-full min-h-[91.1vh] font-poppins">
      {/* Navegación */}
      <div className="mt-3 ml-5 flex items-center">
        <p
          onClick={() => navigate("/admin/clientes")}
          className="text-subtitle cursor-pointer hover:text-text text-xs sm:text-base md:text-lg"
        >
          Clientes
        </p>
        <p className="mx-3 text-subtitle text-xs md:text-base">/</p>
        <p
          onClick={() => navigate(-1)}
          className="text-subtitle cursor-pointer hover:text-text text-xs sm:text-base md:text-lg"
        >
          Rodrigo Silva Bilbao
        </p>
        <p className="mx-3 text-subtitle text-xs md:text-base">/</p>
        <p className="text-text text-xs sm:text-base md:text-lg">
          {podcast?.name || "Nombre del podcast"}
        </p>
      </div>

      {/* Contenedor principal */}
      <div className="contenedor flex flex-wrap gap-5 justify-around mt-10">
        {/* Detalles del podcast */}
        <div className="w-[300px] relative md:w-[600px] lg:w-[800px] h-[400px] shadow border rounded-lg p-5">
          <h1 className="text-text text-xl sm:text-2xl md:text-3xl font-semibold">
            {podcast?.name || "Nombre del podcast"}
          </h1>

          {/* Indicador de plan activo */}
          {podcast?.planActive && (
            <p className="text-green-500 bg-green-100 w-[100px] text-center rounded-lg p-1 text-sm mt-1">
              Plan Activo
            </p>
          )}

          {/* Indicador de plan mensual */}
          {podcast?.monthlyPlan && (
            <p className="text-purple-500 bg-purple-100 w-[100px] text-center rounded-lg p-1 text-sm mt-1">
              Plan mensual
            </p>
          )}

          {/* Descripción del podcast */}
          <p className="text-subtitle text-lg mt-1">{podcast?.description}</p>

          {/* Indicador de nueva idea */}
          {podcast?.newIdea && (
            <p className="bg-black text-white absolute top-2 right-4 rounded-lg p-1">
              Nueva idea
            </p>
          )}

          {/* Detalles adicionales del plan */}
          {podcast?.monthlyPlan && (
            <div>
              <p> Solo audio: {podcast.onlyAudio === true ? "Sí" : "No"}</p>
            </div>
          )}

          {/* Información del plan activo */}
          {podcast?.planActive && (
            <div>
              <p> Plan: {podcast.plan?.name}</p>
              <p>Price ${podcast.plan?.price} mxn</p>
            </div>
          )}
        </div>

        {/* Información de pago */}
        <div className="w-[300px] md:w-[600px] lg:w-[800px] h-[400px] shadow border rounded-lg p-5">
          Info de pago
        </div>
      </div>

      {/* Contenedor de eventos */}
      <div className="contenedor flex justify-center mt-6">
        <div className="w-[300px] md:w-[600px] lg:w-[1500px] h-[320px] border rounded-lg overflow-y-auto p-4">
          <div className="w-full space-y-4">
            {eventos && eventos.length > 0 ? (
              eventos.map((podcast) => (
                <div
                  key={podcast.id}
                  className="bg-card relative border border-border rounded-lg shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center sm:space-x-6 hover:shadow-xl transition-shadow duration-300"
                >
                  <div
                    className={`p-2 sm:p-3 ${podcast.iconBg} rounded-full mb-4 sm:mb-0`}
                  >
                    <Headphones
                      className={`w-5 h-5 sm:w-6 sm:h-6 ${podcast.iconColor}`}
                    />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">
                      {podcast.title}
                    </h2>
                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 text-subtitle">
                      <div className="flex items-center space-x-2 mb-2 sm:mb-0">
                        <CalendarIcon className="w-4 h-4" />
                        <p>{podcast.date}</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Clock className="w-4 h-4" />
                        <p>{podcast.time}</p>
                      </div>
                    </div>
                    <p className="text-sm text-subtitle mt-2">
                      Plataforma: {podcast.platform}
                    </p>
                  </div>
                  <Popover
                    trigger="click"
                    content={
                      <div>
                        <div className="flex text-red-500 items-center cursor-pointer">
                          <Trash className="w-4 h-4 mr-1" />
                          <p>Cancelar Evento</p>
                        </div>
                      </div>
                    }
                    placement="bottomRight"
                  >
                    <button className="absolute top-4 right-6">
                      <MoreHorizontal className="w-6 h-6 text-gray-600" />
                    </button>
                  </Popover>
                </div>
              ))
            ) : (
              <div className='text-text'>
                <h1 className='text-2xl'>No hay Eventos...</h1>
                <p className='text-subtitle'>Agrega un evento en tu sección de podcast</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}